// React and related imports
import React from 'react';

// Flowbite components
import { Badge } from 'flowbite-react';

// Constants
import { statusIcons } from '../../common/constants/statusIcons';

// Shared components
import { StatusBadge } from '../Shared/StatusBadge/StatusBadge';

// i18n hooks
import { useTranslation } from 'react-i18next';

interface GroupedContentAccordionHeaderProps {
  title: string;
  contentContextType: string;
  status: string;
  contentsNumber: number;
}

export const GroupedContentAccordionHeader: React.FC<
  GroupedContentAccordionHeaderProps
> = ({ title, contentContextType, status, contentsNumber }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      {/* Title in Arabic */}
      <span className="me-3 cursor-default">{title}</span>

      {/* Badge with content type */}
      <Badge className="cursor-default" color="gray">
        {t(`contentContextTypes.${contentContextType}`)}

        {/* Status Indicator */}
        <span
          className={`ms-2 inline-block h-2 w-2 rounded-full ${statusIcons[status]}`}
        ></span>
      </Badge>

      {/* Badge with contents number in context */}
      <StatusBadge
        className="ms-3 cursor-default"
        variant={contentsNumber > 0 ? 'success' : 'error'}
      >
        {t(`contentContext.contentsIncluded`, {
          number: contentsNumber,
        })}
      </StatusBadge>
    </div>
  );
};
